<template>
  <div
    class="ce-checkboxFilter"
    :class="{'disabled': disabled}">
    <checkbox
      :disabled="!!disabled"
      :id="`key-${filterKey}`"
      :model-value="value"
      @update:model-value="toggle">
      {{ label }}
    </checkbox>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import Checkbox from 'components/Checkbox.vue';

export default {
  props: {
    filterKey: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    value: {
      type: Boolean || null,
      default: null
    },
    disabled: {
      type: Boolean || null,
      default: false
    }
  },
  components: { Checkbox },
  computed: {
    ...mapGetters(['urlFilters'])
  },
  methods: {
    toggle(value) {
      const url = this.$cloneObject(this.urlFilters);
      this.$trackEvent('filter', 'toggle', {
        filterType: 'checkbox',
        filterKey: this.filterKey,
        filterLabel: this.label,
        value
      });

      if (!value) {
        delete url[this.filterKey];
      } else {
        url[this.filterKey] = true;
      }

      this.$store.dispatch('setUrlFilters', url);
    }
  }
};
</script>

<style lang="less">
  @import (reference) "~styles/includes/base";

  .ce-checkboxFilter {
    margin-bottom: @space-3;
    padding: @space-2 @space-3;
    background: @ce-filter-background-color;
    border-radius: @border-radius;
    border: 1px solid @ce-filter-border-color;
    color: @ce-filter-color;
    .noselect();

    &.disabled {
      display: none;
    }
  }
</style>
